import {createRoot} from "react-dom/client";

type ClientRoot = ReturnType<typeof createRoot>;

declare global {
  interface Window {
    __FIG_CLIENT_ROOTS__?: Record<string, ClientRoot>;
  }
}

export function getClientRoot(elementId = "root") {
  const domNode = document.getElementById(elementId);

  if (!domNode) {
    throw new Error(`Missing #${elementId} element`);
  }

  window.__FIG_CLIENT_ROOTS__ = window.__FIG_CLIENT_ROOTS__ || {};
  window.__FIG_CLIENT_ROOTS__[elementId] = window.__FIG_CLIENT_ROOTS__[elementId] || createRoot(domNode);

  return window.__FIG_CLIENT_ROOTS__[elementId];
}
